<template>
<div class="home">
    <CustomNav :showLocation="true" :navBarTitle="'我要领养'" :locationTxt="locationTxt" />
    <div class="banner">
        <a href="https://mp.weixin.qq.com/s/yUqvsvguXNsSDOzO42ZM5w">
            <img src="/img/guide.png" alt="">
        </a>
    </div>
    <div class="speciesList">
        <div :id="'item_' + item.id" class="tabItem" :class="tabCurrentIndex == index ? 'active' : ''" v-for="(item,index) in aSpeciesData" :data-index="index" :data-id="item.id" :key="item.id" @click="tabChange(item.id,index)">
            <div>{{item.name}}</div>
        </div>
    </div>
    <List :listData="aData" :imgUrl="imgUrl" />
    <Loading :type="'circle'" :hidden="!showLoading" :tips="''" />
    <NoMore v-if="noMore && hasData === true" />
    <Empty v-if="hasData === false" />
    <Tips :show="showTips" :tips="tipsText" />

</div>
</template>

<script>
// @ is an alias to /src
import {
    mapActions,
} from 'vuex';
import Loading from '@/components/Loading.vue';
import List from '@/components/List.vue';
import CustomNav from '@/components/CustomNav.vue';
import NoMore from '@/components/NoMore.vue';
import Empty from '@/components/Empty.vue';
import Tips from '@/components/Tips.vue';

import {
    fetchList,
} from '@/api/getList';
import {
    fetchSpeciesList,
} from '@/api/getSpeciesList';
import {
    fetchAreaID,
} from '@/api/getAreaIdByLocation';
import { wxShare } from '@/utils/wxShare.js';

export default {
    name: 'home',
    components: {
        Loading,
        CustomNav,
        List,
        NoMore,
        Empty,
        Tips,
    },
    data() {
        return {
            showTips: false,
            tipsText: '请确保已打开手机定位服务',
            publicPath: process.env.BASE_URL,
            showLoading: true,
            noMore: false,
            hasData: true,
            locationTxt: '定位中...',
            aSpeciesData: [{
                id: 0,
                name: '全部',
            }],
            tabCurrentIndex: 0,
            aData: [],
            imgUrl: '',
            listQuery: {
                page: 1,
                species_id: 0,
                area_id: 0,
            },
        };
    },
    mounted() {
        this.init();
        wxShare();
    },
    deactivated(){
        // 监听页面滚动
        window.removeEventListener('scroll', this.onScroll, true);
    },
    methods: {
        ...mapActions([
            'setPosition', // 将 `this.increment()` 映射为 `this.$store.dispatch('increment')`
        ]),

        // 初始化数据
        init() {
            // 获取宠物类别列表
            this.setSpeciesList();
            // 获取定位
            this.getPositon()
                .then((res) => {
                    this.getDataByAreaID();
                })
                .catch((err) => {
                    console.log(err)
                    // 获取全部
                    this.locationTxt = '全国';
                    this.getList();
                });
            window.addEventListener('scroll', this.onScroll, true);
        },
        // 获取定位
        getPositon() {
            return new Promise((resolve, reject) => {
                if (this.$store.state.position === '') { // 初始化
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition((res) => {
                            this.setPosition({
                                lat: res.coords.latitude,
                                lng: res.coords.longitude,
                            });
                            resolve();
                        }, (err) => {
                            // alert('请确保已打开手机定位服务')
                            this.showTips = true
                            this.tipsText = '请确保已打开手机定位服务',
                            setTimeout(() => {
                                this.showTips = false;
                                this.tipsText = '';
                            }, 2000);
                            this.locationTxt = '全国';
                            reject();
                        });
                    } else {
                        this.showTips = true
                        this.tipsText = '该浏览器不支持获取地理位置',
                        setTimeout(() => {
                            this.showTips = false;
                            this.tipsText = '';
                        }, 2000);
                        reject();
                    }
                } else {
                    resolve();
                    // this.getDataByAreaID()
                }
            });
        },

        // 获取宠物列表
        getList() {
            fetchList(this.listQuery).then((response) => {
                const oData = response.data;
                if (oData.code == 1) {
                    this.aData = oData.data;
                    this.imgUrl = oData.img_url;
                    if (oData.data.length < 10) {
                        this.showLoading = false;
                        this.noMore = true;
                    }
                } else if (oData.code == 0) {
                    this.showLoading = false;
                    this.hasData = false;
                }

            }).catch((err) => {
                console.log(err);
            });
        },

        // 坐标换取城市ID，通过城市ID获取数据
        getDataByAreaID() {
            if (!!this.$store.state.position.lat) {
                const url = 'https://apis.map.qq.com/ws/geocoder/v1/';
                this.$jsonp(url, {
                        key: 'A4NBZ-PETCU-DGLVT-2Y6ZS-JQ733-SDBCW',
                        callbackName: 'callback',
                        output: 'jsonp',
                        location: this.$store.state.position.lat + ',' + this.$store.state.position.lng,
                    }).then((json) => {
                        const address = json.result.address;
                        this.listQuery.area_id = json.result.ad_info.adcode;
                        this.locationTxt = json.result.ad_info.city || '全国';
                        this.getList();
                    }).catch((err) => {
                        console.log(err);
                    });
            } else {
                this.locationTxt = '全国';
                this.listQuery.area_id = '';
                this.clearData();
                this.getList();
            }
        },

        // 设置宠物类别，先查询本地缓存是否有，否则请求接口获取
        setSpeciesList() {
            return new Promise((resolve, reject) => {
                if (localStorage.getItem('speciesList')) {
                    this.aSpeciesData = this.aSpeciesData.concat(JSON.parse(localStorage.getItem('speciesList')));
                    resolve();
                } else {
                    fetchSpeciesList().then((response) => {
                        const oData = response.data;
                        if (oData.code == 1) {
                            this.aSpeciesData = oData.data;
                            localStorage.setItem('speciesList', JSON.stringify(oData.data));
                        }
                        resolve();
                    }).catch((err) => {
                        console.log(err);
                        reject();
                    });
                }
            });
        },
        // tab切换获取数据
        tabChange(id, index) {
            if (this.tabCurrentIndex === index) {
                return;
            }
            this.tabCurrentIndex = index;
            this.getDataBySpecies(id, index);
        },
        clearData() {
            this.page = 1;
            this.aData = [];
            this.hasData = null;
            this.noMore = false;
            this.listQuery.page = 1;
            this.listQuery.species_id = '';
        },
        // 根据宠物类别获取数据
        getDataBySpecies(id, index) {
            this.clearData();
            this.listQuery.page = 1;
            this.listQuery.species_id = id;

            this.showLoading = true;
            fetchList(this.listQuery).then((response) => {
                const oData = response.data;
                if (oData.code == 1) {
                    this.aData = oData.data;
                    this.hasData = true;
                    if (oData.data.length < 10) {
                        this.showLoading = false;
                        this.noMore = true;
                    }
                } else if (oData.code == 0) {
                    this.showLoading = false;
                    this.noMore = true;
                    this.hasData = false;
                }

            }).catch((err) => {
                console.log(err);
            });
        },
        // 加载更多
        loadmore() {
            if (this.noMore || this.hasData === false) {
                return;
            }
            this.showLoading = true;
            this.listQuery.page += 1;
            fetchList(this.listQuery).then((response) => {

                const oData = response.data;
                if (oData.code == 1) {
                    this.aData = this.aData.concat(oData.data);
                    if (oData.data.length < 10) {
                        this.showLoading = false;
                        this.noMore = false;
                    }
                } else if (oData.code == 0) {
                    this.showLoading = false;
                    this.noMore = true;
                }

            }).catch((err) => {
                console.log(err);
            });
        },
        // 页面触底
        onScroll() {
            const innerHeight = document.querySelector('#app').clientHeight;

            const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;

            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (innerHeight <= (clientHeight + scrollTop) && scrollTop !== 0) {
                this.loadmore();
            }
        },
    },
};
</script>
<style lang="css">
img {
    width: 100%;
    height: 100%;
}
.banner {
    width: 100%;
    max-width: 768px;
    max-height: 367.8px;
    padding-bottom: 5px;
    height: calc((100vw - 20px)*0.48);
}
.banner a{
    display: flex;
    align-items: center;
    justify-content: center;
}
.banner img{
    border-radius: 12px;
    width: calc(100% - 20px);
    box-shadow: 0 2px 4px 0 rgba(2,7,28,0.25);

}
.speciesList {
    height: 72px;
    line-height: 72px;
    width: 100%;
    box-sizing: border-box;
    background: #ffffff;
    z-index: 9;
    font-family: PingFangSC-Medium;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    text-align: left;
    position: sticky;
    top: 4rem;
}
.tabItem {
    display: inline-block;
    padding: 0 20px;
    text-align: center;
    font-size: 17px;
    color: #1D1D1D;
    box-sizing: border-box;

}
.tabItem div {
    display: inline;
    position: relative;
    color: #C2C2C2;
}
.active div {
    color: #1D1D1D;
    z-index: 1;
}
.active div:after {
    content: '';
    display: block;
    width: 100%;
    height: 8px;
    color: #F7CE3E;
    position: absolute;
    z-index: -1;
    left: 0;
    bottom: 0;
    background-image: linear-gradient(90deg, #FFE895 0%, #F8C921 74%);
    box-shadow: 0 -2px 4px 0 rgba(218,174,17,0.50);
}
</style>
